var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { on: { click: _vm.sendTorosClickEvent } }, [
    _c("div", { staticClass: "hotview_wrap" }, [
      _c(
        "a",
        {
          staticClass: "thumb_hotview",
          class: _vm.CAT,
          attrs: { href: _vm.linkUrl }
        },
        [
          _c("img", {
            staticClass: "img_thumb",
            attrs: { src: _vm.thumbnailUrl, alt: _vm.altMessage }
          }),
          _vm._v(" "),
          !_vm.hasImage
            ? _c("span", { staticClass: "wrap_txt" }, [
                _c("span", { staticClass: "inner_txt" }, [
                  _c("span", { staticClass: "txt_thumb" }, [
                    _c("span", { staticClass: "txt_cont" }, [
                      _vm._v(_vm._s(_vm.article.content))
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.isMagazine
        ? _c("div", { staticClass: "detail_hotview" }, [
            _c(
              "a",
              {
                staticClass: "desc_hotview",
                class: _vm.CAT,
                attrs: { href: _vm.linkUrl }
              },
              [_vm._v(_vm._s(_vm.article.content))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrap_belong" }, [
              _c(
                "a",
                { staticClass: "txt_cont", attrs: { href: _vm.linkUrl } },
                [_vm._v(_vm._s(_vm.title))]
              )
            ])
          ])
        : _c("span", { staticClass: "detail_hotview" }, [
            _c(
              "a",
              {
                staticClass: "desc_hotview",
                class: _vm.CAT,
                attrs: { href: _vm.linkUrl }
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "cmt_empty",
                class: _vm.CAT,
                attrs: { href: _vm.linkUrl }
              },
              [
                _vm._v("댓글 "),
                _c("span", { staticClass: "num_placeholder" }, [
                  _vm._v(_vm._s(_vm.article.commentCount))
                ])
              ]
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }